import axios from 'axios';
import AppConfig from 'config';

const FilaController = {
  async listFilaTranscricao(jwtToken) {
    try {
      const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}filas_page/getqueuetranscriptions`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error('Error fetching transcription queue:', error);
      throw error;
    }
  },

  async listFilaLLM(jwtToken) {
    try {
      const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}filas_page/getqueuequestions`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error('Error fetching LLM queue:', error);
      throw error;
    }
  },
  async listTotalTranscriptions(jwtToken) {
    try {
      const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}filas_page/getqueuetranscriptions_quantity`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error('Error fetching LLM queue:', error);
      throw error;
    }
  },
  async listTotalQuestions(jwtToken) {
    try {
      const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}filas_page/getqueuequestions_quantity`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error('Error fetching LLM queue:', error);
      throw error;
    }
  },
  async ListMasterQueue(jwtToken) {
    try {
      const response = await axios.get(`${AppConfig.BACKEND_URL_REFATORADO}filas_page/getmasterqueue`, {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error('Error fetching transcription queue:', error);
      throw error;
    }
  },
};

export default FilaController;